import {Service} from "@/services/Service";

export class TierService extends Service {
    constructor(axios) {
        super(axios, "/reportes");
        // this.fields = [
        //     "username": this.$localStorageService.,
        //     "password": "",
        // ]
    }

    obtenerReporte(params) {
        return this.http.post(this.getUrl(['/obtener/tier']), params)
            .then((response) => response.data)
            .catch(e =>this.onError(e))
            .finally(() => {
                this.onFinaly();
            })
    }

}